import { Price } from '@kanda-libs/ks-design-library';
import { CalculationsValues } from '../useCalculations';
import useBorrow from './useBorrow';

export interface CalcuationRowBorrowProps {
  values: CalculationsValues;
}

const CalcuationRowBorrow: React.FunctionComponent<CalcuationRowBorrowProps> =
  function ({ values }) {
    const { valid, label, secondLine } = useBorrow(values);
    if (valid)
      return (
        <div>
          <Price
            amount={values.amount}
            poundsClassName="text-16-24"
            centsClassName="text-16-24"
            color="text-neutral-700"
            className="ml-auto"
          />
        </div>
      );
    return (
      <div className="flex flex-col">
        <p className="text-16-24 text-right">{label}</p>
        {secondLine && <p className="text-16-24 text-right">{secondLine}</p>}
      </div>
    );
  };

export default CalcuationRowBorrow;
